/**
 * IntelliGems A/B Test: Free shipping indicator in cart drawer
 *
 * Control (A): data-free-shipping-indicator="false"
 * Variant (B): data-free-shipping-indicator="true"
 *
 * Dev preview: ?free_shipping_indicator_test=b
 *
 * Shows only when cart.item_count > 0.
 * Injects into Upcart via upcartDocumentOrShadowRoot + public selectors.
 */
(function () {
  'use strict';

  if (window.__freeShippingIndicatorABTestInit) return;
  window.__freeShippingIndicatorABTestInit = true;

  var BODY_ATTR = 'data-free-shipping-indicator';
  var ROOT_ATTR = 'data-free-shipping-indicator-root';
  var MARK_ATTR = 'data-free-shipping-indicator-injected';
  var STYLE_ID = 'free-shipping-indicator-ab-shadow-style';

  var applying = false;
  var debounceTimer = null;
  var retryTimers = [];
  var cartCache = null;
  var cartFetch = null;
  var hostedBanner = null;

  var SHADOW_CSS =
    '.free-shipping-indicator-ab{display:none!important;width:100%;margin:0;padding:0.85rem 1.1rem 0.7rem;box-sizing:border-box;background:#fff;font-family:inherit;border-bottom:1px solid #ececec;}' +
    '.free-shipping-indicator-ab[data-has-items="true"]{display:block!important;}' +
    '.free-shipping-indicator-ab__label{margin:0 0 0.7rem;padding:0;font-size:0.92rem;font-weight:400;line-height:1.35;text-align:left;color:#1a1a1a;}' +
    '.free-shipping-indicator-ab__label strong{font-weight:700;}' +
    '.free-shipping-indicator-ab__bar{position:relative;display:flex;align-items:center;min-height:2.4rem;padding-right:2.15rem;}' +
    '.free-shipping-indicator-ab__track{width:100%;height:8px;background:#ececec;border-radius:999px;overflow:hidden;}' +
    '.free-shipping-indicator-ab__fill{display:block;height:100%;width:0;background:#1c5949;border-radius:999px;transition:width .35s ease;}' +
    '.free-shipping-indicator-ab__badge{position:absolute;right:0;top:50%;transform:translateY(-50%);width:2.4rem;height:2.4rem;border-radius:50%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;background:#fff;border:1.5px solid #1c5949;color:#1c5949;}' +
    '.free-shipping-indicator-ab--earned .free-shipping-indicator-ab__badge{background:#1c5949;border:3px solid #fff;box-shadow:0 0 0 1.5px #1c5949;color:#fff;}' +
    '.free-shipping-indicator-ab__badge svg{width:1.35rem;height:1.35rem;display:block;}';

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('free_shipping_indicator_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;
    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function parseNumber(value) {
    var number = parseInt(value, 10);
    return isNaN(number) ? 0 : number;
  }

  function cartItemCount() {
    if (cartCache && typeof cartCache.item_count === 'number') return cartCache.item_count;
    return 0;
  }

  function hasItems() {
    return cartItemCount() > 0;
  }

  function getUpcartRoot() {
    if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot;

    var host =
      document.querySelector('upcart-cart-drawer') ||
      document.querySelector('#upCart') ||
      document.querySelector('#upcart') ||
      document.querySelector('[data-upcart-cart]') ||
      document.querySelector('[class*="upcart-"]');

    if (!host) return null;
    return host.shadowRoot || host;
  }

  function queryUpcart(selector) {
    var root = getUpcartRoot();
    if (!root || !root.querySelector) return null;
    return root.querySelector(selector);
  }

  function updateProgress(root, cart) {
    if (!root) return;

    var items = cart && typeof cart.item_count === 'number' ? cart.item_count : cartItemCount();
    var show = items > 0;
    root.setAttribute('data-has-items', show ? 'true' : 'false');
    root.style.display = show ? 'block' : 'none';

    var threshold = parseNumber(root.getAttribute('data-threshold'));
    var total = cart && typeof cart.total_price === 'number'
      ? cart.total_price
      : parseNumber(root.getAttribute('data-total'));

    var percent = 100;
    var earned = true;

    if (threshold > 0) {
      percent = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
      earned = total >= threshold;
    }

    var fill = root.querySelector('[data-free-shipping-indicator-fill]');
    if (fill) fill.style.width = percent + '%';

    var label = root.querySelector('[data-free-shipping-indicator-label]');
    if (label) {
      label.innerHTML = earned
        ? 'You have earned <strong>free shipping</strong>.'
        : 'Spend more to get <strong>free shipping</strong>.';
    }

    root.classList.toggle('free-shipping-indicator-ab--earned', earned);
    root.setAttribute('aria-valuenow', String(percent));
    root.setAttribute('data-total', String(total));
  }

  function getTemplateBanner() {
    var template = document.getElementById('free-shipping-indicator-ab-template');
    if (template && template.content) {
      var fromTemplate = template.content.querySelector('[' + ROOT_ATTR + ']');
      if (fromTemplate) return fromTemplate.cloneNode(true);
    }

    var existing = document.querySelector('#sidebar-cart [' + ROOT_ATTR + ']');
    if (existing) return existing.cloneNode(true);

    var banner = document.createElement('div');
    banner.className = 'free-shipping-indicator-ab free-shipping-indicator-ab--earned';
    banner.setAttribute(ROOT_ATTR, '');
    banner.setAttribute('data-threshold', '0');
    banner.setAttribute('data-has-items', 'false');
    banner.setAttribute('role', 'progressbar');
    banner.setAttribute('aria-label', 'Free shipping progress');
    banner.innerHTML =
      '<p class="free-shipping-indicator-ab__label" data-free-shipping-indicator-label>You have earned <strong>free shipping</strong>.</p>' +
      '<div class="free-shipping-indicator-ab__bar" aria-hidden="true">' +
        '<div class="free-shipping-indicator-ab__track">' +
          '<div class="free-shipping-indicator-ab__fill" data-free-shipping-indicator-fill style="width:100%"></div>' +
        '</div>' +
        '<span class="free-shipping-indicator-ab__badge">' +
          '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<g fill="currentColor">' +
              '<rect x="2.2" y="11.4" width="6.6" height="1.7" rx="0.85"/>' +
              '<rect x="3.2" y="15.15" width="5" height="1.7" rx="0.85"/>' +
              '<rect x="2.2" y="18.9" width="6.6" height="1.7" rx="0.85"/>' +
              '<path d="M12.4 8.6h8.2c.32 0 .62.14.82.38l4.7 5.7c.12.16.2.36.2.56V21.2h-1.9a2.45 2.45 0 0 0-4.72 0h-4.1a2.45 2.45 0 0 0-4.72 0H9.4V9.6c0-.55.45-1 1-1h2z"/>' +
              '<circle cx="14.55" cy="21.2" r="1.95"/>' +
              '<circle cx="23.55" cy="21.2" r="1.95"/>' +
            '</g>' +
          '</svg>' +
        '</span>' +
      '</div>';
    return banner;
  }

  function ensureShadowStyle(root) {
    if (!root || !root.querySelector) return;
    if (root.querySelector('#' + STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = SHADOW_CSS;
    if (root.firstChild) root.insertBefore(style, root.firstChild);
    else root.appendChild(style);
  }

  function findUpcartInsertPoint(root) {
    var announcement =
      root.querySelector('.upcart-public-announcement') ||
      root.querySelector('.upcart-announcement') ||
      root.querySelector('[class*="upcart-public-announcement"]') ||
      root.querySelector('[class*="announcement"]');

    if (announcement && announcement.parentNode) {
      return { parent: announcement.parentNode, before: announcement };
    }

    var header =
      root.querySelector('.upcart-public-header') ||
      root.querySelector('.upcart-header') ||
      root.querySelector('[class*="upcart-public-header"]') ||
      root.querySelector('[class*="CartHeader"]') ||
      root.querySelector('header');

    if (header && header.parentNode) {
      return { parent: header.parentNode, after: header };
    }

    var body =
      root.querySelector('.upcart-public-cart-body') ||
      root.querySelector('[class*="upcart-public-"]') ||
      root.querySelector('[class*="CartBody"]');

    if (body && body.parentNode) {
      return { parent: body.parentNode, before: body };
    }

    return { parent: root, before: root.firstChild || null };
  }

  function insertBanner(point, banner) {
    if (!point || !point.parent) return;
    if (point.before && point.before.parentNode === point.parent) {
      point.parent.insertBefore(banner, point.before);
      return;
    }
    if (point.after && point.after.parentNode === point.parent) {
      if (point.after.nextSibling) point.parent.insertBefore(banner, point.after.nextSibling);
      else point.parent.appendChild(banner);
      return;
    }
    if (point.parent.firstChild) point.parent.insertBefore(banner, point.parent.firstChild);
    else point.parent.appendChild(banner);
  }

  function syncNativeBanners() {
    var banners = document.querySelectorAll('#sidebar-cart [' + ROOT_ATTR + ']');
    for (var i = 0; i < banners.length; i++) {
      updateProgress(banners[i], cartCache);
    }
  }

  function removeHostedBanner() {
    if (hostedBanner && hostedBanner.parentNode) {
      hostedBanner.parentNode.removeChild(hostedBanner);
    }
  }

  function syncUpcartBanner() {
    if (!isVariantB() || !hasItems()) {
      removeHostedBanner();
      return;
    }

    var root = getUpcartRoot();
    if (!root) return;

    ensureShadowStyle(root);

    if (!hostedBanner) {
      hostedBanner = getTemplateBanner();
      hostedBanner.setAttribute(MARK_ATTR, 'true');
    }

    updateProgress(hostedBanner, cartCache);
    hostedBanner.style.cssText =
      'display:block!important;width:100%;box-sizing:border-box;background:#fff;position:relative;z-index:5;';

    if (!hostedBanner.isConnected || !root.contains(hostedBanner)) {
      insertBanner(findUpcartInsertPoint(root), hostedBanner);
    }
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      document.documentElement.classList.toggle('free-shipping-indicator-b', variantB);

      if (!variantB) {
        syncNativeBanners();
        removeHostedBanner();
        return;
      }

      syncNativeBanners();
      syncUpcartBanner();
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function retryAfterCartChange() {
    var delays = [0, 80, 200, 400, 700, 1200, 2000, 3200];
    for (var i = 0; i < retryTimers.length; i++) clearTimeout(retryTimers[i]);
    retryTimers = [];
    for (var d = 0; d < delays.length; d++) {
      retryTimers.push(setTimeout(refreshCart, delays[d]));
    }
  }

  function fetchCartThenApply() {
    if (cartFetch) return cartFetch;

    var cartUrl = (window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js';
    cartFetch = fetch(cartUrl)
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        cartCache = cart || { item_count: 0, total_price: 0 };
        applyVariant();
      })
      .catch(function () {
        applyVariant();
      })
      .then(function () {
        cartFetch = null;
      });

    return cartFetch;
  }

  function refreshCart() {
    cartFetch = null;
    fetchCartThenApply();
  }

  function isCartUrl(url) {
    return /\/cart\/(add|change|update|clear)/i.test(String(url || ''));
  }

  function subscribeUpcart() {
    var subs = [
      'upcartSubscribeCartLoaded',
      'upcartSubscribeAddedToCart',
      'upcartSubscribeItemRemoved',
      'upcartSubscribeCartOpened',
      'upcartSubscribeCartClosed'
    ];

    for (var i = 0; i < subs.length; i++) {
      if (typeof window[subs[i]] === 'function') {
        try {
          window[subs[i]](function () {
            retryAfterCartChange();
          });
        } catch (e) {}
      }
    }

    // Legacy fallbacks
    ['upcartOnCartLoaded', 'upcartOnAddToCart', 'upcartOnItemRemoved'].forEach(function (name) {
      if (typeof window[name] === 'function') return;
      try {
        window[name] = function () {
          retryAfterCartChange();
        };
      } catch (e) {}
    });
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    fetchCartThenApply();
    subscribeUpcart();

    // Upcart API may load after us
    var tries = 0;
    var waitForUpcart = setInterval(function () {
      tries += 1;
      subscribeUpcart();
      if (getUpcartRoot()) scheduleApply();
      if (tries > 40) clearInterval(waitForUpcart);
    }, 250);

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      if (applying) return;

      var shouldApply = false;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'attributes') {
          shouldApply = true;
          break;
        }

        if (mutation.type === 'childList' && isVariantB() && hasItems()) {
          if (!hostedBanner || !hostedBanner.isConnected) {
            shouldApply = true;
            break;
          }
        }
      }

      if (shouldApply) scheduleApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active', 'class'],
      childList: true,
      subtree: true
    });

    document.addEventListener('gem:variant:changed', applyVariant);
    document.addEventListener('cart:refresh', retryAfterCartChange);
    document.addEventListener('product:added', retryAfterCartChange);
    document.addEventListener('upcart:open', retryAfterCartChange);
    document.addEventListener('upcart:refresh', retryAfterCartChange);

    ['upcart:opened', 'upcart:updated', 'cart:updated', 'cart:change', 'cart:added'].forEach(function (name) {
      document.addEventListener(name, retryAfterCartChange);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest(
        '[name="add"], [data-action="add-to-cart"], .ProductForm__AddToCart, button[type="submit"][name="add"], [href*="/cart/add"]'
      );
      if (trigger) retryAfterCartChange();
    }, true);

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var input = arguments[0];
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var request = nativeFetch.apply(this, arguments);
        if (isCartUrl(url)) {
          request.then(function () { retryAfterCartChange(); }).catch(function () {});
        }
        return request;
      };
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fsCartUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (isCartUrl(this.__fsCartUrl)) {
        this.addEventListener('loadend', function () { retryAfterCartChange(); });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
